export default __webpack_public_path__ + "static/media/logoMyBlend.cf82eab0.svg";